import Game from '@Game';
import BaseScene from "@Scenes/BaseScene";
import Network from '@Networks/Localhost';

/*------------------ Config --------------------*/
import * as Scenes from '@Config/scenes';
import { Leaderboards } from '@Config/leaderboards';
import LeaderboardEntry from '@Leaderboards/LeaderboardEntry';
import LeaderboardPlayer from '@Leaderboards/LeaderboardPlayer';
import Leaderboard from '@Leaderboards/Leaderboard';

/*----------------- Players Scene ---------------*/

class PlayersScene extends BaseScene
{
    constructor()
    {
        super(Scenes.PLAYERS);
    }

    /**
     * Creates the scene
     */
    public async create()
    {
        this.enableShutdown();

        const playerLeaderboardEntry = await this.getPlayerLeaderboardEntry();

        this.scene.launch(Scenes.PLAYER, playerLeaderboardEntry);

        if( Network.context.getID() )
        {
            const constextPlayersLeaderboardEntries = await this.getContextPlayersLeaderboardEntries();

            this.scene.launch(Scenes.CHALLENGERS, constextPlayersLeaderboardEntries);
        }
    }

    /**
     * Returns the main leaderboard
     */
    private getLeaderboard(): Leaderboard
    {
        let leaderboardID = Leaderboards.GLOBAL.id

        if (Network.context.getID())
        {
            leaderboardID = Leaderboards.CONTEXTUAL.id;
        }

        return Game.leaderboards[leaderboardID];
    }

    /**
     * Returns
     */
    private async getPlayerLeaderboardEntry(): Promise<Networks.LeaderboardEntry>
    {
        const leaderboard = this.getLeaderboard();

        let playerLeaderboardEntry: Networks.LeaderboardEntry = await leaderboard.getPlayerEntryAsync();

        if (!playerLeaderboardEntry)
        {
            const player = LeaderboardPlayer.export(Network.player);

            playerLeaderboardEntry = new LeaderboardEntry({
                rank: 1,
                score: 0,
                timestamp: Date.now(),
                extraData: '{}',
                formattedScore: '0',
                player: player
            });
        }

        return playerLeaderboardEntry;
    }

    /**
     * Returns context players leaderboard entries
     */
    private async getContextPlayersLeaderboardEntries(): Promise<Networks.LeaderboardEntry[]>
    {
        const leaderboard = this.getLeaderboard();

        let contextLeaderboardEntries: Networks.LeaderboardEntry[] = await leaderboard.getEntriesAsync(5, 0);

        if (!contextLeaderboardEntries)
        {
            contextLeaderboardEntries = [];
        }

        const leaderboardContextIDs = contextLeaderboardEntries.map((entry) =>
        {
            return entry.getPlayer().getID();
        })

        const connectedPlayerID = Network.player.getID();

        const contextualPlayers = await Network.context.getPlayersAsync();

        const missingLeaderboardPlayers = contextualPlayers.filter((player) =>
        {
            return leaderboardContextIDs.indexOf(player.getID()) === -1;
        });

        contextLeaderboardEntries = [...contextLeaderboardEntries];

        for( const missingPlayer of missingLeaderboardPlayers )
        {
            const leaderboardPlayer = LeaderboardPlayer.export(missingPlayer);

            contextLeaderboardEntries.push(new LeaderboardEntry({
                rank: contextLeaderboardEntries.length + 1,
                score: 0,
                timestamp: Date.now(),
                extraData:'{}',
                formattedScore:'0',
                player: leaderboardPlayer
            }));
        };

        return contextLeaderboardEntries.filter((leaderboardEntry)=>{
            return leaderboardEntry.getPlayer().getID() !== connectedPlayerID;
        });;
    }

    /**
     * Shuts down the scene
     */
    public shutdown()
    {
        this.scene.stop(Scenes.PLAYER);
        this.scene.stop(Scenes.CHALLENGERS);
    }
}

export default PlayersScene;